import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FieldInputContainer, themeColor, themeFontWeight, themeFontSize } from '@elparking/components'

const mediaScreenMobile = props => `@media screen and (max-width: ${props.theme.screens.medium})`

export const LoginContent = styled.div`
    width: 100%;
    background: ${themeColor('white')};
    max-width: 100%;
    box-shadow: 0px 4px 12px 0px rgba(0,0,0, 0.08);
    border: 1px solid ${themeColor('lightGray40')};
    padding: 16px;
    ${mediaScreenMobile} {
        border: 0;
        box-shadow: 0;
    }
`

const TitleBarHr = styled.div`
    text-align: center;
    margin-bottom: 16px;
    position: relative;
    color:${themeColor('gray60')};
    display: flex;
`

const TitleBarContent = styled.hr`
    background: ${themeColor('gray60')};
    margin-top: 5px;
    height: 1px;
    width: 100%;
    display: block;
`

const TitleBarText = styled.hr`
    font-weight:${themeFontWeight('book')};
    font-size:${themeFontSize('xSmall')};
    width: 100%;
    white-space: nowrap;
    padding: 0 8px;
`

export const TitleBar = ({ children }) => (<TitleBarContent><TitleBarHr /><TitleBarText>{ children }</TitleBarText><TitleBarHr /></TitleBarContent>)

TitleBar.propTypes = {
    children: PropTypes.node,
}

export const BlinkingInput = styled(FieldInputContainer)`
    animation: blinkingAnimation 0.6s 3;

    @keyframes blinkingAnimation {
        50% { background: ${themeColor('accent')}; }
    }
`
